import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import analyticsHelpers from './helpers/analytics-helpers';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        gaPageView: '/real-estate-agent-reviews',
        pageView: {
          category: 'real-estate-agent-reviews',
          action: 'PageView',
          value: 'home',
        },
      },
    },
  ],
});

router.beforeEach((to, from, next) => {

  //Check if we are actually changing routes and there is a google Analytics page view avalaible
  if (from.name != to.name && to.meta.gaPageView) {
    analyticsHelpers.gaPageView(to.meta.gaPageView);
  }

  next();

});

export default router;
